<template>
  <div class="tabs">
    <div
      class="tab"
      :class="[selectedTab === tab ? 'active-tab' : '']"
      v-for="tab in tabs"
      :key="tab"
      @click="selectedTab = tab"
    >
      {{ tab }}
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  emits: ["tabChange"],
  name: "DodChatTabs",
  data() {
    return {
      selectedTab: "Wszystko",
      tabs: ["Wszystko", "Komentarze", "Aktywność"],
    };
  },
  watch: {
    selectedTab() {
      this.$emit("tabChange", this.selectedTab);
    },
  },
  methods: {},
};
</script>

<style scoped>
.tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
  gap: 1rem;
}
.tab {
  width: 33%;
  background: rgb(234, 231, 231);
  height: 40px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border: 1px solid rgb(193, 188, 188);
  cursor: pointer;
  border-radius: 0.5rem;
}

.active-tab {
  background: rgb(251, 134, 42);
  background: linear-gradient(
    90deg,
    rgba(251, 134, 42, 1) 0%,
    rgba(241, 76, 82, 1) 49%,
    rgba(229, 8, 129, 1) 100%
  );
  border: none;
  color: #fff;
}
</style>
